/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-15 11:39:00
 */

import Video from '../video';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import VideoApi, { VideoDOI } from '../api/videoApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumCloud  from 'src/enums/EnumCloud';
import alertOperateVideoModal from '../operateVideoModal';
import EnumOperates from 'src/enums/enumOperates';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';

export default class VideoService extends ListPageService {
    ctx: Video;

    constructor(ctx: Video) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '账号名称',
                field: 'name',
                minWidth: 120,
            },
            {
                headerName: 'appkey',
                field: 'appkey',
                minWidth: 260,
            },
            {
                headerName: '云端类型',
                field: 'type',
                minWidth: 50,
                cellRenderer(params) {
                    let data: VideoDOI.RowDataI = params.data;
                    return EnumCloud.findId(data.type).getName();
                },
            },
            {
                headerName: 'secret',
                field: 'secret',
                minWidth: 300,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 160,
                maxWidth: 160,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: UserConfigDOI.RowDataI = params.data;
                            let res = await alertOperateVideoModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: UserConfigDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: CommonSelect,
                label: '云端类型：',
                field: 'type',
                props: { value: null, dataSource: EnumCloud.getList() },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateVideoModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await VideoApi.delete(ids[0]);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<VideoDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await VideoApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
